<kendo-card width="260px">
  <kendo-card-header class="k-hstack">
    <div>
      <h1 kendoCardTitle>Ch: {{GetHardwareChannel() }} {{ measurementDescription.description }}</h1>
      <p kendoCardSubtitle>Dep: {{ measurementDescription.department }} Ref:  {{ measurementData.department }} </p>
      <p kendoCardSubtitle>Type: {{ measurementData.description}} </p>
    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>

    <div> Refresh rate:   {{ measurementData.refreshrate   }}  sec <B> {{ Status(measurementData.status) }}</B></div>
    <div> Convert time:  {{ measurementData.timestamp   }}  mS (average)</div>
    <div> Access: {{ measurementData.measurementaccess}} </div>

    <div> Raw Value : {{ measurementData.rawvalue}} </div>
    <div> Owner : {{ measurementData.owner}} </div>
    <div> Department : {{ measurementData.department_name}}, Ref:  {{ measurementData.department }} </div>

    <app-meting-gauge [measurementData]="measurementData"></app-meting-gauge>

    <kendo-card-footer >
      <div> Full channel: {{ measurementDescription.channelfull }} == {{ measurementDescription.channelfull }} </div>
      <div> ADC: In 0x{{ measurementData.tmsc_input.toString(16).toUpperCase()}} Para
        0x{{ measurementData.tmsc_parameter.toString(16).toUpperCase()}}     </div>
    </kendo-card-footer>
  </kendo-card-body>
</kendo-card>
